import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_metadata } from "@swc/helpers/_/_ts_metadata";
import { ClientModel, AbstractPost } from "@devowl-wp/utils";
import { request } from "../utils";
import { action, computed, reaction, runInAction } from "mobx";
import { RootStore } from "../store";
class BlockerModel extends AbstractPost {
    get templateModel() {
        var _this_data_meta;
        return RootStore.get.cookieStore.templatesBlocker.get((_this_data_meta = this.data.meta) == null ? void 0 : _this_data_meta.presetId);
    }
    get rules() {
        var _this_data;
        return (_this_data = this.data) == null ? void 0 : _this_data.meta.rules.split("\n");
    }
    get tcfVendors() {
        var _this_data;
        // In lite version this can be `null`
        if (!((_this_data = this.data) == null ? void 0 : _this_data.meta.tcfVendors)) {
            return [];
        }
        return this.data.meta.tcfVendors.split(",").filter(Boolean).map(Number);
    }
    get tcfPurposes() {
        var _this_data;
        // In lite version this can be `null`
        if (!((_this_data = this.data) == null ? void 0 : _this_data.meta.tcfPurposes)) {
            return [];
        }
        return this.data.meta.tcfPurposes.split(",").filter(Boolean).map(Number);
    }
    get services() {
        var _this_data;
        return (_this_data = this.data) == null ? void 0 : _this_data.meta.services.split(",").filter(Boolean).map(Number);
    }
    get rootStore() {
        return this.collection.store.rootStore;
    }
    get isUpdateAvailable() {
        for (const { post_id } of this.rootStore.optionStore.templateNeedsUpdate){
            if (post_id === this.data.id) {
                return true;
            }
        }
        return false;
    }
    constructor(collection, data = {}){
        super(collection, data);
        reaction(()=>{
            var _this_data;
            return (_this_data = this.data) == null ? void 0 : _this_data.usedTemplate;
        }, (template)=>runInAction(()=>{
                if (template) {
                    RootStore.get.cookieStore.addBlockerTemplates([
                        template
                    ]);
                }
            }), {
            fireImmediately: true
        });
    }
    setName(name) {
        this.data.title.raw = name;
    }
    setStatus(status) {
        this.data.status = status;
    }
    setDescription(purpose) {
        this.data.content.raw = purpose;
    }
    setMeta(meta) {
        this.data.meta = meta;
    }
    transformDataForPatch() {
        const data = super.transformDataForPatch();
        return {
            title: data.title,
            content: data.content,
            status: data.status,
            meta: data.meta,
            slug: data.title
        };
    }
    afterPatch() {
        this.collection.store.blockers.store.rootStore.optionStore.fetchCurrentRevision();
    }
    afterDelete() {
        this.collection.store.blockers.store.rootStore.optionStore.fetchCurrentRevision();
    }
    afterPersist() {
        this.collection.store.blockers.store.rootStore.optionStore.fetchCurrentRevision();
    }
}
_ts_decorate([
    computed,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", void 0)
], BlockerModel.prototype, "templateModel", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", void 0)
], BlockerModel.prototype, "rules", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", void 0)
], BlockerModel.prototype, "tcfVendors", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", void 0)
], BlockerModel.prototype, "tcfPurposes", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", void 0)
], BlockerModel.prototype, "services", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", void 0)
], BlockerModel.prototype, "rootStore", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", void 0)
], BlockerModel.prototype, "isUpdateAvailable", null);
_ts_decorate([
    action,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        String
    ]),
    _ts_metadata("design:returntype", void 0)
], BlockerModel.prototype, "setName", null);
_ts_decorate([
    action,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof PostStatus === "undefined" ? Object : PostStatus
    ]),
    _ts_metadata("design:returntype", void 0)
], BlockerModel.prototype, "setStatus", null);
_ts_decorate([
    action,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        String
    ]),
    _ts_metadata("design:returntype", void 0)
], BlockerModel.prototype, "setDescription", null);
_ts_decorate([
    action,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        Object
    ]),
    _ts_metadata("design:returntype", void 0)
], BlockerModel.prototype, "setMeta", null);
BlockerModel = _ts_decorate([
    ClientModel.annotate({
        keyId: "id",
        namespace: "wp/v2",
        request,
        create: {
            path: "/rcb-blocker"
        },
        patch: {
            path: "/rcb-blocker/:id"
        },
        delete: {
            path: "/rcb-blocker/:id"
        }
    }),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        Object,
        typeof Partial === "undefined" ? Object : Partial
    ])
], BlockerModel);
export { BlockerModel };
